// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__EcSGG","loader":"Loader_loader__FvJ1x","spin":"Loader_spin__lVJfa"};